import { cn } from '@april9au/react-common/utils';

import { SectionHeader } from './section-header';

/**
 * Narrative text block (heading + paragraphs), optionally paired with an
 * image. Reusable for About/Our Story style content on the homepage or a
 * dedicated About page.
 */
export function ContentSection({
  id,
  eyebrow,
  heading,
  paragraphs,
  image,
  imageAlt,
  align = 'left',
  className,
}: {
  id?: string;
  eyebrow?: string;
  heading: string;
  paragraphs: Array<string>;
  image?: string;
  imageAlt?: string;
  align?: 'left' | 'center';
  className?: string;
}) {
  return (
    <section id={id} className={cn('section', className)}>
      <div className={cn('container', image && 'grid items-center gap-12 lg:grid-cols-2')}>
        <div>
          <SectionHeader eyebrow={eyebrow} heading={heading} align={image ? 'left' : align} className="mb-6" />

          <div className="max-w-[68ch] space-y-4">
            {paragraphs.map((paragraph, index) => (
              <p key={index} className="text-body">
                {paragraph}
              </p>
            ))}
          </div>
        </div>

        {image ? (
          <img src={image} alt={imageAlt ?? ''} className="w-full rounded-md object-cover shadow-[var(--shadow-card)]" />
        ) : null}
      </div>
    </section>
  );
}
